// Mappe la chaîne `icon` du catalogue (backend/game_catalog.py, ex. "skull",
// "hammer", "biohazard") vers un composant d'icône @lucide/svelte réel --
// un seul point de vérité pour la page liste/wizard/instance, plutôt que de
// dupliquer ce mapping trois fois. Toute icône de catalogue non prévue ici
// retombe sur `Server` (icône neutre) plutôt que de planter.
import {
	Skull,
	Hammer,
	Biohazard,
	Sword,
	PawPrint,
	Crosshair,
	Moon,
	Ghost,
	Wrench,
	Target,
	Axe,
	Blocks,
	Server
} from '@lucide/svelte';

export const SERVER_ICONS: Record<string, typeof Server> = {
	skull: Skull,
	hammer: Hammer,
	biohazard: Biohazard,
	sword: Sword,
	paw: PawPrint,
	crosshair: Crosshair,
	moon: Moon,
	ghost: Ghost,
	wrench: Wrench,
	target: Target,
	axe: Axe,
	blocks: Blocks
};

export function serverIcon(icon: string | undefined | null) {
	return (icon && SERVER_ICONS[icon]) || Server;
}
